/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Default properties for each component type.
 * Used as a safety net when adding or rendering components
 * to ensure all required properties exist.
 */

const COMMON_SPACING = {
  paddingTop: "15",
  paddingBottom: "15",
  paddingLeft: "25",
  paddingRight: "25",
  marginTop: "0",
  marginBottom: "0",
  marginLeft: "0",
  marginRight: "0",
};

const DEFAULT_BUTTON_STYLE = {
  style: "default" as const,
  defaultColor: "#3b82f6",
  hoverColor: "#2563eb",
  textColor: "#ffffff",
  hoverTextColor: "#ffffff",
  borderColor: "#3b82f6",
  isTransparent: false, 
  exploreButtonradius: 0,
  fontweight: "",
  fontSize: "12px",
  Italic: false,
  Underline: "",
};

const COMMON_LINK_PROPS = {
  buttonType: "",
  buttonUrl: "",
  buttonTarget: "_blank",
  pageId: "",
  emailField: "",
  phoneField: "",
  popupId: "",
  seeMoreLink: "",
};

export const COMPONENT_DEFAULTS: Record<string, Record<string, any>> = {
  "page-layout": {
    layoutSettings: {
      showNavbar: true,
      showBrandName: true,
      brandNameColor: "#000000",
      navbarBackground: "#ffffff",
      logoAlignment: "left",
      banner: { type: "color", color: "#ffffff" },
      buttonStyle: { ...DEFAULT_BUTTON_STYLE },
      socialLinks: [],
      themeTextColor: "#1f2937",
      themeFont: "Inter",
    },
  },

  "navbar-single": {
    pageSettings: { bodyColor: "#ffffff" },
    showNavbar: true,
    showBrandName: true,
    brandNameColor: "#000000",
    navbarBackground: "#ffffff",
    logoAlignment: "left",
    brandLogo: "",
    isFixed: true,
    logowidth: "70",
    logoheight: "auto",
    ...COMMON_SPACING,
  },

  banner: {
    banner: { type: "color", color: "#ffffff", size: "cover" },
    title: "Title Text",
    subtitle: "Subtitle Text",
    text: "",
    titleColor: "#000000",
    subtitleColor: "#666666",
    textColor: "",
    buttonText: "",
    ...COMMON_LINK_PROPS,
    buttonStyle: { ...DEFAULT_BUTTON_STYLE },
    fontFamily: "",
    fontWeight: "",
    fontSize: "",
    fontStyleItalic: false,
    fontStyleUnderline: "none",
    ...COMMON_SPACING,
  },

  "social-links": {
    socialLinks: [],
    position: "footer",
    iconSize: "md",
    iconColor: "#3b82f6",
    backgroundColor: "transparent",
  },

  "offcanvas-settings": {
    navbarBackground: "transparent",
    showNavbar: true,
    logoAlignment: "left",
    showOffcanvas: true,
    offcanvasTitle: "Title",
    offcanvasSubtitle: "Subtitle",
    offcanvasDisplayType: "title",
    offcanvasAlignment: "center",
    exploreButtonText: "Explore More",
    offcanvasBgColor: { type: "color", color: "#ffffff" },
    banner: { type: "color", color: "#787878", size: "cover" },
    buttonStyle: { ...DEFAULT_BUTTON_STYLE },
    offcanvasButtonAlignment: "center",
    offcanvasTitlecolor: "#000000",
    offcanvasSubtitlecolor: "#000000",
    offcanvasDefaultHeight: 250,
    logowidth: "70",
    logoheight: "auto",
  },

  hero: {
    heading: "Build Amazing Websites",
    subheading: "Create beautiful web pages",
    backgroundColor: "#1e40af",
    textColor: "#ffffff",
    textAlign: "center",
    headingtextcolor: "#ffffff",
    headingfontsize: "display-2",
    subheadingfontsize: "1rem",
    buttonText: "",
    ...COMMON_LINK_PROPS,
    buttonStyle: { ...DEFAULT_BUTTON_STYLE },
    fontFamily: "",
    fontWeight: "",
    fontSize: "",
    fontStyleItalic: false,
    fontStyleUnderline: "none",
    ...COMMON_SPACING,
  },

  text: {
    text: "<p>Text content goes here...</p>",
    fontSize: "16px",
    fontWeight: "400",
    textColor: "#4b5563",
    textAlign: "left",
    backgroundColor: "#ffffff",
    fontFamily: "",
    fontStyleItalic: false,
    fontStyleUnderline: "none",
    letterSpacing: "",
    ...COMMON_SPACING,
  },

  button: {
    buttonText: "Click Me",
    backgroundColor: "#ffffff",
    textColor: "#ffffff",
    borderRadius: "0",
    textAlign: "center",
    ...COMMON_LINK_PROPS,
    buttonStyle: { ...DEFAULT_BUTTON_STYLE },
    fontFamily: "",
    fontWeight: "",
    fontSize: "",
    ...COMMON_SPACING,
  },

  card: {
    title: "Feature Title",
    text: "Card description",
    imageSrc: "",
    imageAlt: "Image",
    orientation: "landscape",
    logoAlignment: "left",
    imageHeight: "auto",
    imageWidth: "100%",
    imageRadius: "0",
    imagepaddingLeft: "0",
    imagepaddingRight: "0",
    imagepaddingTop: "0",
    imagepaddingBottom: "0",
    contentpaddingTop: "15",
    contentpaddingBottom: "15",
    contentpaddingLeft: "25",
    contentpaddingRight: "25",
    titleColor: "#000000",
    titlefontsize: "",
    titlefontweight: "",
    titleItalic: false,
    titleUnderline: "none",
    backgroundColor: "#ffffff",
    textColor: "#1f2937",
    textAlign: "center",
    headingtextcolor: "#000000",
    headingfontsize: "display-2",
    buttonText: "",
    ...COMMON_LINK_PROPS,
    buttonStyle: { ...DEFAULT_BUTTON_STYLE },
    fontFamily: "",
    fontWeight: "",
    fontSize: "",
    fontStyleItalic: false,
    fontStyleUnderline: "none",
    ...COMMON_SPACING,
  },

  image: {
    imageSrc: "",
    imageAlt: "Image",
    borderRadius: "0.5rem",
    orientation: "landscape",
    logoAlignment: "center",
    imageHeight: "auto",
    imageWidth: "100%",
    ...COMMON_LINK_PROPS,
    ...COMMON_SPACING,
  },

  video: {
    videoSourceType: "link",
    videoSrc: "",
    imageAlt: "Video",
    borderRadius: "0.5rem",
    videoOrientation: "landscape",
    autoPlay: false,
    muted: false,
    loop: false,
    videoControl: true,
    ...COMMON_SPACING,
  },

  "spin-wheel": {
    heading: "Spin to Win!",
    wheelOptions: [
      { label: "Prize 1", code: "P1" },
      { label: "Prize 2", code: "P2" },
      { label: "Prize 3", code: "P3" },
    ],
    wheelColors: [
      "#bfd8bd",
      "#98c9a3",
      "#dde7c7",
      "#f4b942",
      "#ff7a59",
      "#7f95d1",
    ],
    wheelBorder: "#77bfa3",
    showEmailPopup: false,
    emailPopupTitle: "Verify your email to spin",
    emailPopupDescription: "Enter your email address before spinning the wheel.",
    emailPlaceholder: "your@email.com",
    emailButtonText: "Continue",
    backgroundColor: "#f8f9fa",
    textColor: "#2c3e50",
    textAlign: "center",
    buttonStyle: { ...DEFAULT_BUTTON_STYLE },
    ...COMMON_SPACING,
  },

  "scratch-card": {
    heading: "Scratch to Reveal!",
    scratchText: "You Win a 20% Discount!",
    scratchColor: "#c0c0c0",
    scratchRevealColor: "#ffd700",
    showEmailPopup: false,
    emailPopupTitle: "Verify your email to play",
    emailPopupDescription: "Enter your email address before scratching the card.",
    emailPlaceholder: "your@email.com",
    emailButtonText: "Continue",
    backgroundColor: "#ffffff",
    textColor: "#2c3e50",
    textAlign: "center",
    buttonStyle: { ...DEFAULT_BUTTON_STYLE },
    fontFamily: "",
    fontWeight: "",
    fontSize: "",
    ...COMMON_SPACING,
  },

  tabs: {
    tabItems: [
      { label: "Tab 1", content: "Content for tab 1" },
      { label: "Tab 2", content: "Content for tab 2" },
    ],
    activeTab: 0,
    backgroundColor: "#ffffff",
    textColor: "#2c3e50",
    fontFamily: "",
    fontWeight: "",
    fontSize: "",
    fontStyleItalic: false,
    fontStyleUnderline: "none",
    ...COMMON_SPACING,
  },

  accordion: {
    accordionItems: [
      { title: "Section 1", content: "<p>Content</p>" },
      { title: "Section 2", content: "<p>Content</p>" },
    ],
    backgroundColor: "#ffffff",
    textColor: "#2c3e50",
    titleColor: "#000000",
    navbarBackground: "#ffffff",
    titleBackground: "#ffffff",
    contentBackground: "#222020",
    titlefont: "poppins",
    accordionicons: "chevron",
    fontFamily: "",
    fontWeight: "",
    fontSize: "",
    fontStyleItalic: false,
    fontStyleUnderline: "none",
    ...COMMON_SPACING,
  },

  carousel: {
    carouselItems: [
      { imageSrc: "", title: "Slide 1", description: "Description" },
    ],
    autoPlay: true,
    showDots: true,
    showArrows: true,
    backgroundColor: "#ffffff",
    ...COMMON_SPACING,
  },

  "form-subscribe": {
    heading: "Subscribe to our Newsletter",
    text: "Get the latest updates",
    submitButtonText: "Subscribe",
    backgroundColor: "#ffffff",
    textColor: "#2c3e50",
    buttonStyle: { ...DEFAULT_BUTTON_STYLE },
    fontFamily: "",
    fontWeight: "",
    fontSize: "",
    ...COMMON_SPACING,
  },

  survey: {
    heading: "Survey",
    subheading: "",
    surveyQuestions: [],
    submitButtonText: "Submit",
    enableSteps: false,
    backgroundColor: "#ffffff",
    textColor: "#2c3e50",
    buttonStyle: { ...DEFAULT_BUTTON_STYLE },
    fontFamily: "",
    fontWeight: "",
    fontSize: "",
    ...COMMON_SPACING,
  },

  "product-grid": {
    heading: "Products",
    productsToShow: 4,
    productgridColumns: 2,
    seeMoreText: "See more",
    seeMoreLink: "",
    showPrice: true,
    currency: "₹",
    showDescription: false,
    backgroundColor: "#f5f5f5",
    textColor: "#4a4a4a",
    borderRadius: "1rem",
    ...COMMON_LINK_PROPS,
    fontFamily: "",
    fontWeight: "",
    fontSize: "",
    ...COMMON_SPACING,
  },

  "attribute-grid": {
    heading: "Attributes",
    imageType: "square",
    attributeItems: [],
    attributeColumns: 4,
    attributeIconSize: "48",
    backgroundColor: "#ffffff",
    textColor: "#4b5563",
    headingtextcolor: "#1f2937",
    fontFamily: "",
    fontWeight: "",
    fontSize: "",
    ...COMMON_SPACING,
  },

  "quick-links": {
    heading: "Quick links",
    quickLinksItems: [],
    backgroundColor: "#ffffff",
    itemBackgroundColor: "#f5f5f5",
    textColor: "#000000",
    iconColor: "#000000",
    arrowColor: "#999999",
    itemBorderRadius: 30,
    headingtextcolor: "#000000",
    headingfontsize: "18px",
    fontSize: "14px",
    fontFamily: "",
    fontWeight: "",
    ...COMMON_SPACING,
  },

  iframe: {
    iframeSrc: "https://example.com",
    iframeWidth: "100%",
    iframeHeight: "400",
    borderRadius: "0",
    ...COMMON_SPACING,
  },
};

/** Component types that include a buttonStyle property */
export const BUTTON_COMPONENT_TYPES = new Set([
  'hero', 'button', 'card', 'banner', 'spin-wheel', 'scratch-card',
  'form-subscribe', 'form-contact', 'survey', 'offcanvas-settings', 'page-layout',
]);

/**
 * Ensures a component has all default properties for its type.
 * Only fills in missing properties — never overwrites existing ones.
 * If globalButtonStyle is provided and the component type supports buttons,
 * it will be used instead of the hardcoded DEFAULT_BUTTON_STYLE.
 */
export function ensureComponentDefaults(component: any, globalButtonStyle?: Record<string, any>): any {
  if (!component || !component.type) return component;

  const defaults = COMPONENT_DEFAULTS[component.type];
  if (!defaults) return component;

  const mergedProperties = { ...defaults };

  // If a global button style is provided, use it as the default for button-capable components
  if (globalButtonStyle && BUTTON_COMPONENT_TYPES.has(component.type) && mergedProperties.buttonStyle) {
    mergedProperties.buttonStyle = { ...DEFAULT_BUTTON_STYLE, ...globalButtonStyle };
  }

  // Overlay existing properties on top of defaults
  if (component.properties) {
    for (const key of Object.keys(component.properties)) {
      const val = component.properties[key];
      if (val !== undefined && val !== null) {
        // Deep merge objects (like buttonStyle, banner) but not arrays
        if (
          typeof val === "object" &&
          !Array.isArray(val) &&
          typeof mergedProperties[key] === "object" &&
          !Array.isArray(mergedProperties[key])
        ) {
          // When inheriting a global button style, keep inherited buttonStyle values
          // as the source of truth for new components (template button defaults shouldn't override it).
          if (key === "buttonStyle" && globalButtonStyle && BUTTON_COMPONENT_TYPES.has(component.type)) {
            mergedProperties[key] = { ...val, ...mergedProperties[key] };
          } else {
            mergedProperties[key] = { ...mergedProperties[key], ...val };
          }
        } else {
          mergedProperties[key] = val;
        }
      }
    }
  }

  return {
    ...component,
    properties: mergedProperties,
  };
}
